<template>
  <el-cascader
    :options="areaList"
    :value="value"
    v-model="defaultArea"
    :props="defaultParams"
    :style="{'width':'300px'}"
    :disabled="disabled"
  ></el-cascader>
</template>

<script>
import db from "@/api/db";
import url from "@/config/url";
var Db = new db();
export default {
  props: {
    value: {
      type: Array,
      default: []
    },
    series: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      areaList: [],
      defaultArea: [],
      defaultParams: {
        lazy: true,
        series: this.series,
        value: "value",
        label: "label",
        level: "level",
        lazyLoad(node, resolve) {
          const { level, value } = node;
          let params = { level: level + 1, pid: value };
          Db.post(url.getRegionUrl, params).then(resp => {
            let data = resp.data;
            data.forEach(element => {
              element.leaf = level >= this.series;
            });
            resolve(data);
          });
        }
      }
    };
  },
  mounted() {
    this.defaultArea = this.value;
  },
  watch: {
    defaultArea(val) {
      this.$emit("input", val);
    },
    value: {
      handler(val) {
        this.defaultArea = val;
      },
      deep: true
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/dataArea/dataArea.vue